export const showOrHideBadge = (show: boolean) => {
  const badge = document.querySelector<HTMLElement>('#notificationBadge');
  if (badge) {
    badge.style.display = show ? 'block' : 'none';
  }
};
